import React from "react";
import PropTypes from "prop-types";

import DialogFormWithMutation from "dialogs/DialogFormWithMutation";
import { FormGroupTitle, FormTextField } from "ui/Form";

import useFormValidator from "hooks/useFormValidator";

import {
  READ_SERVER_SETTINGS_QUERY,
  UPDATE_ACTION_LOG_SETTINGS,
} from "graphqlQueries/system";

import { ACTION_LOG_ROTATION_PERIOD_TITLE } from "constants/repoSettings";
import { ACTION_LOG_ROTATION_PERIOD } from "constants/mutationArgs/system";

const fieldsWithPlaceForError = [ACTION_LOG_ROTATION_PERIOD];

const UpdateActionLogSettingsDialog = (props) => {
  const { actionLogInfo } = props;

  const initialValues = {
    [ACTION_LOG_ROTATION_PERIOD]: actionLogInfo.rotation_years,
  };

  const dataMapper = (data) => {
    data[ACTION_LOG_ROTATION_PERIOD] = Number(data[ACTION_LOG_ROTATION_PERIOD]);
    return data;
  };

  const { validationSchema } = useFormValidator(
    "update_action_log_period",
    {
      rotation_period: "Rotation period",
    },
    {},
  );

  return (
    <DialogFormWithMutation
      mutationQueries={UPDATE_ACTION_LOG_SETTINGS}
      refetchQueries={[READ_SERVER_SETTINGS_QUERY]}
      initialValues={initialValues}
      validationSchema={validationSchema}
      dataMapper={dataMapper}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="Edit action log settings"
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <FormGroupTitle title="Action log information" />
      <FormTextField
        name={ACTION_LOG_ROTATION_PERIOD}
        label={ACTION_LOG_ROTATION_PERIOD_TITLE}
      />
    </DialogFormWithMutation>
  );
};

UpdateActionLogSettingsDialog.propTypes = {
  smtpInfo: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UpdateActionLogSettingsDialog;
